import type { PreviewKind, Resource } from './types';

type ResourcePreviewModalProps = {
  data: {
    resource: Resource | null;
    kind: PreviewKind;
  };
  actions: {
    onClose: () => void;
  };
};

const ResourcePreviewModal = ({ data, actions }: ResourcePreviewModalProps) => {
  const { resource, kind } = data;

  if (!resource || kind === 'none') {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4"
      onClick={actions.onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="w-full max-w-4xl overflow-hidden rounded-2xl bg-white shadow-xl"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-slate-100 px-4 py-3">
          <div>
            <p className="text-sm font-semibold text-slate-900">{resource.name}</p>
            <p className="text-xs text-slate-400">{resource.type}</p>
          </div>
          <button
            type="button"
            className="flex h-8 w-8 items-center justify-center rounded-full text-slate-400 hover:bg-slate-100"
            aria-label="Close preview"
            onClick={actions.onClose}
          >
            <svg
              className="h-4 w-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M18 6 6 18" />
              <path d="M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="bg-slate-50 p-4">
          {kind === 'image' ? (
            <div className="flex items-center justify-center">
              <img
                src={resource.link}
                alt={resource.name}
                className="max-h-[70vh] w-full object-contain"
              />
            </div>
          ) : kind === 'pdf' ? (
            <iframe
              title={resource.name}
              className="h-[70vh] w-full rounded-lg bg-white"
              src={resource.link}
            />
          ) : (
            <iframe
              title={resource.name}
              className="h-[70vh] w-full rounded-lg bg-white"
              src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                resource.link ?? ''
              )}`}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ResourcePreviewModal;
